import React, {useEffect, useRef, useState} from 'react';
import classNames from "classnames";

const PoweredItem = ({item, activeItem}) => {
    return <li

        className={classNames({
            "powered_by_item": true,
            "active": activeItem === item.title
        })}
    >
        <span className={'powered_by_item_title'}>{item.title}</span>
        <div className={'powered_by_item_icon'}>
            <img width={290} height={146} src={`/img/pages/home/powered_by/${item.icon}.svg`} alt={""}/>
        </div>
    </li>
}

const PoweredBy = ({t}) => {

    const powered_by = t('common:powered_by', {}, {returnObjects: true});

    const [activeItem, setActiveItem] = useState('Hubspot')

    let intervalRef = useRef(null)

    const items = [
        {
            "title": "Hubspot",
            "icon": "hubspot"
        }, {
            "title": "Tether",
            "icon": "tether"
        }, {
            "title": "Bitcoin",
            "icon": "bitcoin"
        }, {
            "title": "Ethereum",
            "icon": "ethereum"
        }, {
            "title": "Google",
            "icon": "google"
        }, {
            "title": "Meta",
            "icon": "meta"
        }, {
            "title": "Discord",
            "icon": "discord"
        }, {
            "title": "Telegram",
            "icon": "telegram"
        }, {
            "title": "X",
            "icon": "x"
        }, {
            "title": "Facebook",
            "icon": "facebook"
        }, {
            "title": "Trust Wallet",
            "icon": "trust_wallet"
        }, {
            "title": "Metamask",
            "icon": "metamask"
        }, {
            "title": "Phantom",
            "icon": "phantom"
        }, {
            "title": "Microsoft",
            "icon": "microsoft"
        }, {
            "title": "Figma",
            "icon": "figma"
        }, {
            "title": "Android",
            "icon": "android"
        }, {
            "title": "Visa",
            "icon": "visa"
        }, {
            "title": "Mastercard",
            "icon": "mastercard"
        },
    ]

    const randomizeActiveItem = (items) => {
        intervalRef.current = setInterval(() => {
            let i = Math.floor(Math.random() * items.length)
            setActiveItem(items[i].title)
        }, 2000)
    }

    useEffect(() => {
        randomizeActiveItem(items)

        let powered_by_items = document.querySelector('.powered_by_items')

        powered_by_items.addEventListener('mouseover', () => {
            setActiveItem('')
            clearInterval(intervalRef.current)
        })
    }, []);


    return (
        <section className={'powered_by'}>
            <div className="container">
                <div className="powered_by_wrapper">
                    <ul className={'powered_by_items'}>
                        <li className={'section_title'}>
                            <h2>{powered_by.title}</h2>
                        </li>
                        {items.map(item => {
                            return <PoweredItem
                                key={item.title}
                                item={item}
                                activeItem={activeItem}
                            />
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default PoweredBy;